<!--  -->
<template>
  <div id="XyContent">
    <div class="cell-item">
      <label class="item-left" v-if="applyData.ApplyType === 1 ||applyData.ApplyType === 2">调课原因</label>
      <label class="item-left" v-if="applyData.ApplyType === 3">代课原因</label>
      <div class="item-right" v-cloak>{{applyInfo.Description}}</div>
    </div>
    <!-- 调课 -->
    <div class="cell-item" v-if="applyData.ApplyType === 1 ||applyData.ApplyType === 2">
      <div v-for="(item,index) in applyInfo.Data" :key="index">
        <div class="item-block">
          <h3 class="h-title" v-cloak>{{item.StudentOrganizationFullName}}</h3>
          <div class="time-item">
            <span class="round1"></span>
            <span v-cloak>
              <span
                class="week"
                v-if="item.SourceClassDate !=='0001-01-01'"
              >{{item.SourceClassDate}}</span>
              <span>第{{item.SourceWeek}}周{{item.SourceWeekName}}{{item.SourceInfo}}</span>
            </span>
          </div>
          <div class="time-item">
            <span class="round2"></span>
            <span v-cloak>
              <span
                class="week"
                v-if="item.TargetClassDate !=='0001-01-01'"
              >{{item.TargetClassDate}}</span>
              <span>第{{item.TargetWeek}}周{{item.TargetWeekName}}{{item.TargetInfo}}</span>
            </span>
          </div>
          <div
            class="subject-teacher"
            v-cloak
            v-if="item.SourceSubjectName  && item.SourceTeacherNames"
          >
            <span>{{item.SourceSubjectName}}</span>
            <span class="week">{{item.SourceTeacherNames}}</span>
          </div>
        </div>
        <div class="divider-line" v-if="applyInfo.Data.length !== (index+1)"></div>
      </div>
    </div>
    <!-- 代课 -->
    <div class="cell-item" v-if="applyData.ApplyType === 3">
      <div v-for="(item,index) in applyInfo.Details" :key="index">
        <div class="item-block">
          <h3 class="h-title" v-cloak>{{item.CoursePlanTableFullName}}</h3>
          <div class="time-item">
            <span class="round1"></span>
            <span class="week">{{item.SourceTeacherName}}</span>
          </div>
          <div class="time-item">
            <span class="round2"></span>
            <span class="week">{{item.SubstituteTeacherName}}</span>
          </div>
          <div class="subject-teacher" v-cloak>
            <span>{{item.SubjectName}}</span>
            <span class="week" v-if="item.SourceClassDate !=='0001-01-01'">{{item.ClassDate}}</span>
            <span>第{{item.Week}}周{{item.TimeDesc}}</span>
          </div>
        </div>
        <div class="divider-line" v-if="applyInfo.Details.length !== (index+1)"></div>
      </div>
    </div>

    <!--0申请中 1待审批 2已通过 3未通过 4已拒绝 5已过期 6已撤回-->
    <div class="cell-item">
      <div>
        <label class="item-left">审批状态</label>
        <div class="item-right" v-cloak>{{applyInfo.SubstituteStatusName}}</div>
      </div>
      <div
        class="divider-line"
        v-if="applyInfo.SubstituteStatus === 2 || applyInfo.SubstituteStatus === 4 ||applyInfo.SubstituteStatus === 3 ||applyInfo.SubstituteStatus === 6"
      ></div>
      <div
        v-if="applyInfo.SubstituteStatus === 2 || applyInfo.SubstituteStatus === 4 ||applyInfo.SubstituteStatus === 3 ||applyInfo.SubstituteStatus === 6 "
      >
        <label class="item-left">审批意见</label>
        <ul>
          <li
            v-for="(explain,index) in applyInfo.Explain"
            :key="index"
            style="margin:50px;"
            v-cloak
          >{{index+1}}、{{explain}}</li>
        </ul>
      </div>
    </div>
    <div class="fotter-fix">
      <span class="cancle-btn" @click="back">取消</span>
      <span class="submit-btn" @click="undo" v-if="applyInfo.SubstituteStatus===1">撤回</span>
    </div>
  </div>
</template>

<script>
import xyapi from "@/common/api";
export default {
  components: {},
  data() {
    return {
      applyData: {
        ApplyType: ""
      },
      applyInfo: {
        Description: "",
        Data: [],
        ApproverDate: "",
        ApproverName: "",
        CreateByDate: "",
        CreateName: "",
        Explain: [],
        SubstituteStatusName: "",
        SubstituteStatus: ""
      }
    };
  },
  created: function() {
    this.applyData = this.$route.query;
  },
  computed: {
    apiBase () {
      return this.xyMApi;
    }
  },
  mounted: function() {
    // console.log(this.applyData.ApplyType);
    if (this.applyData.ApplyType === 1 || this.applyData.ApplyType === 2) {
      this.getAdjustInfo();
    } else if (this.applyData.ApplyType === 3) {
      this.getSubstituteInfo();
    }
  },
  methods: {
    //调课
    getAdjustInfo() {
      this.xy.loading();
      var that = this;
      xyapi
        .get(
          this.$store.state.apiPath +
            "/api/ClasstableGenerateForTeacherAdjustmentApply/GetTeaherApplyInfo",
          {
            appilyID: that.applyData.ID
          }
        )
        .then(res => {
          this.xy.unloading();
          if (res.success) {
            that.applyInfo = res.data;
          } else {
            that.$toast.fail(res.msg);
          }
        })
        .catch(err => {
          that.$toast.fail(err.msg);
        });
    },
    //代课
    getSubstituteInfo() {
      var that = this;
      let url = this.$store.state.apiPath + "/api/ClassTableGenerateForTeacherSubstituteApply/GetSubstituteInfo"
      this.xy.loading();
      xyapi
        .get(url, {
          classTableGenerateForTeacherSubstituteApplyID: that.applyData.ID
        })
        .then(res => {
          that.xy.unloading();
          if (res.success) {
            that.applyInfo = res.data;
          } else {
            that.$toast.fail(res.msg);
          }
        })
        .catch(err => {
          that.$toast.fail(err.msg);
        });
    },
    //撤回
    async undo() {
      if (this.applyData.ApplyType === 3) {
        this.xy.loading();
        let res = await xyapi.post(
          this.apiBase + "/api/ClassTableGenerateForTeacherSubstituteApply/Revoke",
          {
            ClassTableGenerateForTeacherSubstituteApplyID: this.applyData.ID
          }
        );
        if (res.success) {
          this.xy.msgSuc("撤回成功");
          this.back();
        }
        this.xy.unloading();
      } else if (
        this.applyData.ApplyType === 1 ||
        this.applyData.ApplyType === 2
      ) {
        this.xy.loading();
        let res = await xyapi.post(
          this.apiBase +
            "/api/ClasstableGenerateForTeacherAdjustmentApply/RevokeTeacherAdjustmentApply",
          {
            ClassTableGenerateForTeacherAdjustmentApplyID: this.applyData.ID
          }
        );
        this.xy.unloading();
        if (res.success) {
          this.xy.msgSuc("撤回成功");
          this.back();
        }
      }
    },
    //关闭
    back() {
      this.$router.push({ path: "/home/ApprovalTable" });
    }
  }
};
</script>
<style lang='less' >
.cell-item {
  background: #fff;
  padding: 24px 10px 24px 20px;
  font-size: 14px;
  color: #333333;
  margin-top: 15px;
  .item-left {
    display: inline-block;
    vertical-align: top;
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
  }
  .item-right {
    font-size: 28px;
    margin-left: 26px;
    display: inline-block;
    color: #666666;
  }
  .h-title {
    font-size: 28px;
    margin-bottom: 32px;
  }
  .time-item {
    font-size: 26px;
    color: #666666;
    margin-bottom: 32px;
    .round1,
    .round2 {
      width: 13px;
      height: 13px;
      border: 2px solid rgba(226, 226, 227, 1);
      border-radius: 50%;
      display: inline-block;
      vertical-align: middle;
      background-color: transparent;
    }
    .round1 {
      background-color: #e2e2e3;
    }
    .week {
      margin: 0 16px;
    }
  }
  .subject-teacher {
    background: rgba(246, 246, 247, 1);
    border-radius: 14px 0px 14px 0px;
    padding: 10px 29px 10px 19px;
    display: inline-block;
    font-size: 24px;
    color: #666666;
    .week {
      margin: 0 16px;
    }
  }
  .divider-line {
    height: 1px;
    background: #eeeeee;
    margin: 16px 0;
  }
}
.fotter-fix {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 110px;
  background: #fff;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .cancle-btn {
    font-size: 28px;
    padding: 15px 50px;
    border: 1px solid #4196ff;
    border-radius: 38px;
    display: inline-block;
    margin-top: 10px;
    color: #4196ff;
    margin-right: 30px;
    cursor: pointer;
  }
  .submit-btn {
    font-size: 28px;
    padding: 15px 50px;
    background: #4196ff;
    border-radius: 38px;
    display: inline-block;
    margin-top: 10px;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>

